
import { useState } from 'react';

export default function TestimonialsSection() {
  const [currentIndex, setCurrentIndex] = useState(0);

  const testimonials = [
    {
      name: 'Sarah Al-Mansouri',
      role: 'Business Executive',
      image: 'https://public.readdy.ai/ai/img_res/73c6be3085ef132593e772a09c91939e.jpg',
      rating: 5,
      text: 'The therapeutic massage sessions have been life-changing for my chronic back pain. The combination of traditional Chinese medicine and modern techniques is truly remarkable. Highly recommended!'
    },
    {
      name: 'Ahmed Hassan',
      role: 'Engineer',
      image: 'https://readdy.ai/api/search-image?query=middle-eastern-man-engineer-professional-portrait-confident-smile-business-casual-attire-warm-friendly-expression&width=200&height=200&seq=testimonial-2&orientation=squarish',
      rating: 5,
      text: 'After years of stress and tension, I finally found relief through the relaxation therapy and acupuncture treatments. The therapist is incredibly knowledgeable and caring. Best wellness decision I have made.'
    },
    {
      name: 'Fatima Al-Thani',
      role: 'Teacher',
      image: 'https://readdy.ai/api/search-image?query=middle-eastern-woman-teacher-professional-portrait-warm-smile-elegant-hijab-friendly-approachable-appearance&width=200&height=200&seq=testimonial-3&orientation=squarish',
      rating: 5,
      text: 'The hot stone therapy is absolutely divine! I feel rejuvenated after every session. The peaceful atmosphere and professional service make this the best wellness center in Qatar.'
    },
    {
      name: 'Mohammed Al-Kuwari',
      role: 'Athlete',
      image: 'https://readdy.ai/api/search-image?query=middle-eastern-man-athlete-fit-healthy-professional-portrait-confident-sporty-appearance-warm-smile&width=200&height=200&seq=testimonial-4&orientation=squarish',
      rating: 5,
      text: 'As an athlete, recovery is crucial. The deep tissue massage and Chinese medicine treatments have significantly improved my performance and reduced recovery time. Exceptional service!'
    }
  ];

  const nextTestimonial = () => {
    setCurrentIndex((prev) => (prev + 1) % testimonials.length);
  };

  const prevTestimonial = () => {
    setCurrentIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  return (
    <section id="testimonials" className="py-24 bg-gradient-to-b from-teal-50/30 to-white">
      <div className="px-6 lg:px-12 max-w-7xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-4xl lg:text-5xl font-['Fraunces'] font-semibold text-gray-900 mb-4">
            Client Testimonials
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Hear from our satisfied clients about their healing journey
          </p>
        </div>

        <div className="relative max-w-4xl mx-auto">
          <div className="bg-white rounded-2xl shadow-xl p-8 lg:p-12">
            <div className="flex flex-col items-center text-center">
              <img 
                src={testimonials[currentIndex].image}
                alt={testimonials[currentIndex].name}
                className="w-24 h-24 rounded-full object-cover object-top mb-6 border-4 border-teal-100"
              />
              
              <div className="flex gap-1 mb-4">
                {[...Array(testimonials[currentIndex].rating)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-2xl text-amber-400"></i>
                ))}
              </div>

              <p className="text-xl text-gray-700 leading-relaxed mb-6 italic">
                "{testimonials[currentIndex].text}"
              </p>

              <div>
                <div className="font-semibold text-gray-900 text-lg">
                  {testimonials[currentIndex].name}
                </div>
                <div className="text-gray-600">
                  {testimonials[currentIndex].role}
                </div>
              </div>
            </div>
          </div>

          <button
            onClick={prevTestimonial}
            className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-4 lg:-translate-x-16 w-12 h-12 flex items-center justify-center bg-white rounded-full shadow-lg hover:bg-teal-50 transition-all cursor-pointer"
            aria-label="Previous testimonial"
          >
            <i className="ri-arrow-left-s-line text-2xl text-gray-700"></i>
          </button>

          <button
            onClick={nextTestimonial}
            className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-4 lg:translate-x-16 w-12 h-12 flex items-center justify-center bg-white rounded-full shadow-lg hover:bg-teal-50 transition-all cursor-pointer"
            aria-label="Next testimonial"
          >
            <i className="ri-arrow-right-s-line text-2xl text-gray-700"></i>
          </button>

          <div className="flex justify-center gap-2 mt-8">
            {testimonials.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentIndex(index)}
                className={`w-3 h-3 rounded-full transition-all cursor-pointer ${
                  index === currentIndex ? 'bg-teal-700 w-8' : 'bg-gray-300'
                }`}
                aria-label={`Go to testimonial ${index + 1}`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
